export class ObjectKeysBaseValueConverter {
    toView(obj): (string | symbol)[] {
      return Reflect.ownKeys(obj);
    }
  }